import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import HomeIcon from "@mui/icons-material/Home";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";

import { Box, Container, Typography } from "@mui/material";

import whatWeCleanBg from "../../assets/images/what_we_clean_bg.png";
import cardBg from "../../assets/images/what_we_clean_card_bg.png";

const cleaningCategories = [
  {
    title: "Garments",
    icon: <CheckroomIcon />,
    items: [
      "Business Suits",
      "Dress Shirts",
      "Blazers",
      "Winter Coats",
      "Wedding Dresses",
    ],
  },

  {
    title: "Household Items",
    icon: <HomeIcon />,
    items: ["Comforters", "Blankets", "Bedsheets", "Curtains", "Area Rugs"],
  },

  {
    title: "Shoe & Handbag Care",
    icon: <DirectionsRunIcon />,
    items: [
      "Sneaker Cleaning",
      "Shoe Repair",
      "Leather Shoes",
      "Handbag Cleaning",
      "Handbag Repair",
    ],
  },

  {
    title: "Specialty Items",
    icon: <WorkspacePremiumIcon />,
    items: [
      "Leather Garments",
      "Suede Items",
      "Fur Cleaning",
      "Traditional Wear",
      "Alterations & Hemming",
    ],
  },
];

export default function WhatWeClean() {
  return (
    <Box
      sx={{
        py: {
          xs: 4,
          md: 6,
        },

        position: "relative",

        overflow: "hidden",

        backgroundImage: `
        // linear-gradient(
        // rgba(248,251,255,.92),
        // rgba(248,251,255,.92)
        // ),
        url(${whatWeCleanBg})
      `,

        backgroundSize: "cover",

        backgroundPosition: "center",
      }}
    >
      <Container maxWidth="xl">
        {/* HEADING */}

        <Box
          sx={{
            textAlign: "center",

            maxWidth: "900px",

            mx: "auto",
          }}
        >
          <Box
            sx={{
              display: "inline-flex",

              px: 2.5,

              py: 1,

              borderRadius: "50px",

              background: "rgba(0,87,255,.08)",

              color: "#0057FF",

              fontSize: "12px",

              fontWeight: 800,

              letterSpacing: "1px",

              textTransform: "uppercase",
            }}
          >
            What We Clean
          </Box>

          <Typography
            sx={{
              mt: 2,

              fontWeight: 900,

              color: "#07122F",

              lineHeight: 1.05,

              fontSize: {
                xs: "32px",
                sm: "32px",
                md: "56px",
                lg: "56px",
              },
            }}
          >
            Premium Care For
            <br />
            <Box
              component="span"
              sx={{
                background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                WebkitBackgroundClip: "text",

                WebkitTextFillColor: "transparent",
              }}
            >
              Every Item
            </Box>
          </Typography>

          <Typography
            sx={{
              mt: 2,

              maxWidth: "700px",

              mx: "auto",

              color: "#64748B",

              lineHeight: 1.8,

              fontSize: {
                xs: "13px",
                sm: "14px",
                md: "16px",
              },
            }}
          >
            From business attire and everyday laundry to footwear, wedding
            dresses and specialty garments, we ensure every item receives expert
            care.
          </Typography>
        </Box>

        {/* CARDS */}

        <Box
          sx={{
            mt: {
              xs: 4,
              md: 7,
            },

            display: "flex",

            flexWrap: "wrap",

            justifyContent: "center",

            gap: {
              xs: 1.5,
              md: 2.5,
            },
          }}
        >
          {cleaningCategories.map((category, index) => (
            <Box
              key={index}
              sx={{
                flex: {
                  xs: "0 0 calc(50% - 8px)", // 2 per row mobile
                  md: "0 0 calc(25% - 20px)", // 4 per row desktop
                },

                maxWidth: {
                  xs: "calc(50% - 8px)",
                  md: "calc(25% - 20px)",
                },

                minHeight: {
                  xs: 230,
                  md: 260,
                },

                p: {
                  xs: 1.8,
                  md: 2.5,
                },

                borderRadius: "24px",

                position: "relative",

                overflow: "hidden",

                backgroundImage: `
        //   linear-gradient(
        //   rgba(255,255,255,.90),
        //   rgba(248,251,255,.82)
        //   ),
          url(${cardBg})
        `,

                backgroundSize: "cover",

                backgroundPosition: "bottom",

                border: "1px solid rgba(255,255,255,.75)",

                backdropFilter: "blur(18px)",

                boxShadow:
                  "0 12px 35px rgba(0,87,255,.08), inset 0 1px 0 rgba(255,255,255,.9)",

                transition: ".35s",

                "&::before": {
                  content: '""',

                  position: "absolute",

                  left: 0,

                  top: 18,

                  bottom: 18,

                  width: "4px",

                  borderRadius: "20px",

                  background: "linear-gradient(180deg,#0057FF,#1DB6FF)",
                },

                "&:hover": {
                  transform: "translateY(-8px)",

                  boxShadow: "0 25px 60px rgba(0,87,255,.15)",

                  "&::before": {
                    width: "6px",
                  },
                },
              }}
            >
              {/* ICON */}
              <Box
                sx={{
                  width: {
                    xs: 46,
                    md: 58,
                  },

                  height: {
                    xs: 46,
                    md: 58,
                  },

                  borderRadius: "18px",

                  display: "flex",

                  alignItems: "center",

                  justifyContent: "center",

                  color: "#fff",

                  background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                  border: "2px solid rgba(255,255,255,.5)",

                  boxShadow: "0 12px 30px rgba(0,87,255,.25)",

                  mb: 2,

                  "& svg": {
                    fontSize: {
                      xs: 22,
                      md: 28,
                    },
                  },
                }}
              >
                {category.icon}
              </Box>

              {/* TITLE */}
              <Typography
                sx={{
                  fontWeight: 800,

                  color: "#07122F",

                  lineHeight: 1.2,

                  mb: 1.5,

                  fontSize: {
                    xs: "15px",
                    md: "20px",
                  },
                }}
              >
                {category.title}
              </Typography>

              {/* ITEMS */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                {category.items.map((item, idx) => (
                  <Box
                    key={idx}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <CheckCircleIcon
                      sx={{
                        color: "#0057FF",
                        fontSize: {
                          xs: 14,
                          md: 16,
                        },
                      }}
                    />

                    <Typography
                      sx={{
                        color: "#12305F",

                        fontWeight: 600,

                        lineHeight: 1.4,

                        fontSize: {
                          xs: "11px",
                          md: "13px",
                        },
                      }}
                    >
                      {item}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
